// Material Kit 2 React pages
import ELearningAndQuestionPaper from "pages/ElearningAndQuestionPapers/E-LearningAndQuestionPaper";

export default function ELearningAndQuestionPaperPage() {
  return <ELearningAndQuestionPaper />;
}
